var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.27,2.13H8.4c-1.34,0-2.42,1.09-2.42,2.42V43.78c0,1.34,1.09,2.42,2.42,2.42H41.27c1.34,0,2.42-1.09,2.42-2.42V4.56c0-1.34-1.09-2.42-2.42-2.42Zm-.58,41.07H8.98V5.13h31.71V43.2Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.88,16.5h23.9c.81,0,1.46-.66,1.46-1.47v-6.05c0-.81-.66-1.47-1.46-1.47H12.88c-.81,0-1.47,.66-1.47,1.47v6.05c0,.81,.66,1.47,1.47,1.47Zm.53-6.98h22.83v4.98H13.42v-4.98Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.84,40.82H28.91l.06,.08,.09-.08h7.76c.79,0,1.43-.64,1.43-1.43V19.53c0-.79-.64-1.43-1.43-1.43H12.84c-.79,0-1.43,.64-1.43,1.43v19.87c0,.79,.64,1.43,1.43,1.43Zm.57-20.72h5.75l-3.59,2.99,1.28,1.54,5.43-4.52h12.57l-16.77,14.16,1.29,1.53,16.88-14.24v17.28h-4.78l3.3-2.75-1.28-1.54-5.15,4.28H13.42V20.1Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCards);
export default __webpack_public_path__ + "static/media/icon_cards.0e38005e75dcf2a191737259618ab391.svg";
export { ForwardRef as ReactComponent };